<template>
    <div
        :class="[
            isCapacitorEmbed ? '' : 'productpage-backgorund',
            'd-flex flex-column productpage-height overflow-x-hidden overflow-y-scroll',
        ]"
        ref="divOne"
    >
        <div :class="[isCapacitorEmbed ? '' : 'productpage-backgorund', 'mt-sm-3']">
            <div>
                <AnnouncementBanner />

                <div v-if="isGiftCard()">
                    <GiftCardDetailsComponent
                        v-bind:productDetails="productDetails"
                        :stockFlag="stockFlag"
                        :categoryId="categoryId"
                    ></GiftCardDetailsComponent>
                </div>

                <div v-else-if="this.productDetails.typename == 'ComplexProductView'">
                    <ConfiguredProductDetailComponent
                        v-bind:productDetails="productDetails"
                        :stockFlag="stockFlag"
                        :categoryId="categoryId"
                    />
                </div>
                <div v-else>
                    <ExpressPDPComponent
                        v-bind:productDetails="productDetails"
                        :stockFlag="stockFlag"
                        :categoryId="categoryId"
                        v-if="showExpressPdpPage"
                    >
                    </ExpressPDPComponent>
                    <ProductDetailComponent
                        v-if="!showExpressPdpPage"
                        v-bind:productDetails="productDetails"
                        :stockFlag="stockFlag"
                        :categoryId="categoryId"
                    />
                </div>
            </div>
            <RelatedProductsComponent
                v-bind:relatedProducts="productDetails.relatedLinksProduct"
                v-if="
                    !isHandwritingMode &&
                    productDetails.relatedLinksProduct &&
                    productDetails.relatedLinksProduct.length > 0
                "
            />
            <RecentlyViewedComponent
                v-bind:recentlyViewed="recentlyViewedList"
                v-if="!isHandwritingMode"
            />
        </div>
        <FooterBlockContent v-if="showPdpFooter" />
    </div>
</template>
<script>
const baseUrl = import.meta.env.VITE_BASE_URL
// import * as easings from "vuetify/lib/services/goto/easing-patterns";
import RelatedProductsComponent from '@/components/crane/product-detail/RelatedProductsComponent.vue'
import RecentlyViewedComponent from '@/components/crane/product-detail/RecentlyViewedComponent.vue'
import ProductDetailComponent from '@/components/crane/product-detail/ProductDetailComponent.vue'
import ExpressPDPComponent from '@/components/crane/product-detail/ExpressPDPComponent.vue'

import ConfiguredProductDetailComponent from '@/components/crane/product-detail/ConfiguredProductDetailComponent.vue'
import GiftCardDetailsComponent from '@/components/crane/product-detail/GiftCardDetailsComponent.vue'
import FooterBlockContent from '../../components/crane/builderio/FooterBlockContent.vue'

import { getMeta, googleAanalyticsEventPDP, getLable } from '@/services/util.service'
import AnnouncementBanner from '@/components/crane/builderio/AnnouncementBanner.vue'
import { getIsCapacitorEmbed } from '@/plugins/capacitorIframeBack'
import { HANDWRITING_FLAG } from '@/plugins/handwritingMode'

// Converts an HTML description to plain text (tags removed, whitespace collapsed) for the product schema
const htmlToPlainText = (html) => {
    if (!html) return ''
    const text = new DOMParser().parseFromString(html, 'text/html').body.textContent || ''
    return text.replace(/\s+/g, ' ').trim()
}

export default {
    name: 'ProductPage',
    components: {
        RelatedProductsComponent,
        RecentlyViewedComponent,
        ProductDetailComponent,
        FooterBlockContent,
        GiftCardDetailsComponent,
        ConfiguredProductDetailComponent,
        ExpressPDPComponent,
        AnnouncementBanner,
    },
    data: () => ({
        // easings: Object.keys(easings),
        stockFlag: true,
    }),
    metaInfo() {
        const meta = {
            titleTemplate: this.metaData.title,
            title: this.metaData.title,
            description: this.metaData.description,
            keywords: this.metaData.keywords,

            link: [
                {
                    rel: 'canonical',
                    href: `${this.canonical ? window.location.href.split('?')[0] : baseUrl}`,
                },
            ],
        }
        // Product schema lives here so every PDP variant (Express, Detail, Configured, Gift Card) gets it
        if (this.productSchema) {
            meta.script = [{ type: 'application/ld+json', json: this.productSchema }]
        }
        return meta
    },
    computed: {
        isCapacitorEmbed() {
            return getIsCapacitorEmbed()
        },
        categoryListIdWise: function () {
            return this.$store.state.headerCategoryList.categoryListIdWise
        },
        canonical: function () {
            return this.$route.meta.canonical
        },
        sku: function () {
            return this.$route.meta.sku ? this.$route.meta.sku : this.$route.params.sku
        },
        productId: function () {
            return this.$route.meta.id ? this.$route.meta.id : this.$route.params.id
        },
        productDetails: function () {
            return this.$store.state.productOne.productDetails
        },
        recentlyViewedList() {
            return this.$store.state.productList.recentlyViewed
        },
        // Catalog Service returns SEO fields at the product level; customAttribute is the legacy REST shape
        metaData() {
            const legacy = getMeta(this.productDetails.customAttribute)
            const name = this.productDetails.name
            return {
                title:
                    this.productDetails.metaTitle ||
                    legacy.title ||
                    (name ? `${name} | Crane Stationery` : 'Crane Stationery'),
                description: this.productDetails.metaDescription || legacy.description || '',
                keywords: this.productDetails.metaKeyword || legacy.keywords || '',
            }
        },
        productSchema() {
            const product = this.productDetails
            if (!product || !product.sku || !product.name) return null

            const url = product.urlKey
                ? `${baseUrl}/${product.urlKey}`
                : window.location.href.split('?')[0]
            const images = (product.mediaGalleryEntries || [])
                .map((entry) => entry.file)
                .filter((file) => file && file.startsWith('http'))
            const description =
                htmlToPlainText(product.description) || this.metaData.description || product.name

            const schema = {
                '@context': 'https://schema.org',
                '@type': 'Product',
                name: product.name,
                sku: product.sku,
                description,
                url,
                brand: { '@type': 'Brand', name: 'Crane' },
            }
            if (images.length) schema.image = images

            const price = Number(product.specialPrice) || Number(product.price)
            if (price > 0) {
                schema.offers = {
                    '@type': 'Offer',
                    url,
                    price: price.toFixed(2),
                    priceCurrency: 'USD',
                    availability:
                        product.inStock === false
                            ? 'https://schema.org/OutOfStock'
                            : 'https://schema.org/InStock',
                }
            }
            return schema
        },
        categoryId: function () {
            return this.$route.query.categoryId
        },
        fetchInProgress: function () {
            return this.$store.state.productOne.fetchInProgress
        },
        showExpressPdpPage() {
            if (!this.productDetails) return false

            const isMobile = this.$vuetify.display.width <= 767
            const builderVersion = this.productDetails.builderVersion

            const isPersonalize = this.productDetails.isPersonalize === '1'
            if (!isPersonalize) return false

            if (builderVersion === '3.0') {
                // Always show Express for both mobile & desktop
                return true
            } else if (builderVersion === '2.1' && isMobile) {
                // Show Express only on mobile
                return true
            }

            // For 2.0 or others → always ProductDetail
            return false
        },
        /**
         * Handwriting flow (handwriting=true): Capacitor iframe embed and web deep links.
         * Hides Related Products, Recently Viewed, “Craftsmanship of Crane”, and PDP-bottom promo tiles
         * (see RecentlyViewedComponent).
         */
        isHandwritingMode() {
            if (this.$route.query.handwriting === 'true') return true
            return typeof window !== 'undefined' && Boolean(window[HANDWRITING_FLAG])
        },
        /** Footer: hidden only in Designer iframe (capacitor) + handwriting; still shown on web with handwriting=true. */
        showPdpFooter() {
            if (!this.isHandwritingMode) return true
            return !this.isCapacitorEmbed
        },
    },
    watch: {
        sku() {
            this.$store.dispatch('productOne/fetchProductDetails', {
                sku: this.sku,
                productId: this.productId,
            })
            this.recentlyViewed()
            this.scrollToTop()
        },
        productDetails() {
            if (
                this.productDetails &&
                this.productDetails.customAttribute &&
                this.productDetails.customAttribute.length
            ) {
                if (this.productDetails.typename == 'ComplexProductView') {
                    this.$store.dispatch(
                        'productOne/fetchConfiguredProductDetails',
                        this.productDetails.sku
                    )
                }
                googleAanalyticsEventPDP(
                    this.productDetails,
                    'view_item',
                    this.categoryId,
                    this.categoryListIdWise
                )
                if (!this.productDetails.inStock) {
                    this.stockFlag = false
                    if (
                        import.meta.env.NODE_ENV == 'production' &&
                        window.craneCatalog.products.hasOwnProperty(this.productDetails.id)
                    ) {
                        this.$store.dispatch('productOne/updateCatlog')
                        console.log('updateCatlog called')
                    }
                }
            }
        },
    },
    methods: {
        isGiftCard() {
            return this.productDetails?.customAttributes?.some(
                (attr) => attr.attributeCode === 'ac_giftcard'
            )
        },
        scrollToTop() {
            this.$nextTick(() => {
                setTimeout(() => {
                    document.documentElement.scrollTop = 0
                    window.scrollTo(0, 0)
                }, 0)
            })
        },
        recentlyViewed() {
            let productId = this.$route.meta.id ? this.$route.meta.id.toString() : ''

            let checkPoint = localStorage.getItem('cr_recently_viewed_product')
            if (checkPoint) {
                let newVal = localStorage.getItem('cr_recently_viewed_product').split(',')
                if (newVal.indexOf(productId) !== -1) {
                    newVal.splice(newVal.indexOf(productId), 1)
                    this.$store.dispatch('productList/fetchRecentlyViewedList', newVal.toString())
                    newVal.splice(0, 0, productId)
                    localStorage.setItem('cr_recently_viewed_product', newVal)
                } else {
                    this.$store.dispatch('productList/fetchRecentlyViewedList', newVal.toString())
                    newVal.splice(0, 0, productId)
                    localStorage.setItem('cr_recently_viewed_product', newVal)
                }
            } else {
                localStorage.setItem('cr_recently_viewed_product', productId)
            }
        },
    },
    // for PDP page, prevent scroll from bottom to top
    beforeMount() {
        const c = document.scrollingElement // <html> or <body>
        if (c) c.scrollTop = 0
    },
    // mounted() {
    //     window.scrollTo({ top: 0, behavior: "smooth" });
    //     document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
    // },
    async created() {
        await this.$store.dispatch('productOne/fetchProductDetails', {
            sku: this.sku,
            productId: this.productId,
        })

        this.recentlyViewed()
    },
}
</script>
<style src="./product_page.scss" lang="scss" scoped />
